var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8954 12.0718L9.42369 7.59574L13.8954 3.11969C14.4581 2.55641 14.4581 1.63101 13.8954 1.06772C13.3326 0.504443 12.4082 0.504443 11.8455 1.06772L7.37379 5.54381L2.90212 1.06772C2.3394 0.504443 1.41494 0.504443 0.85222 1.06772C0.289495 1.63101 0.289495 2.55641 0.85222 3.11969L5.32389 7.59574L0.85222 12.0718C0.289495 12.6351 0.289495 13.5605 0.85222 14.1238C1.41494 14.6871 2.3394 14.6871 2.90212 14.1238L7.37379 9.6477L11.8455 14.1238C12.4082 14.6871 13.3326 14.6871 13.8954 14.1238C14.4581 13.5605 14.4581 12.6452 13.8954 12.0718Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.66ddbeadb236af36930e6a33daa4b791.svg";
export { ForwardRef as ReactComponent };